import { Button, ControlGroup, InputGroup, Tag } from "@blueprintjs/core";
import cogoToast from "cogo-toast";
import React from "react";
import { apiCallPost, niceDate } from "../fns/util";
import AsyncSelWrap from "../utils/AsyncSelWrap";
import { inject, observer } from "mobx-react";
import _ from "lodash";
import SingleSelectWrapper from "../utils/SingleSelectWrapper";
import { DateInput } from "@blueprintjs/datetime";

class LedgerSearchTopBar extends React.Component {
  state = {
    searchModeGeneral: true,
    isFTS: true,
    ftsText: "",
    searchingItems: false,
    itemSearchResults: [],
    searchItem: null,
    location: null,
    itemId: null,
    createdInEnd: null,
    createdInStart: null,
    isReceived: false,
  };
  getDataGeneral = async () => {
    let obj = {};
    if (!this.state.createdInStart && this.state.createdInEnd) {
      cogoToast.error("You need to put in both start and end intervals.");
      return;
    }
    if (!this.state.approvedInStart && this.state.approvedInEnd) {
      cogoToast.error("You need to put in both start and end intervals.");
      return;
    }
    if (this.state.location) {
      obj["location"] = this.state.location;
    }
    if (this.state.action) {
      obj["action"] = this.state.action;
    }
    if (this.state.serialNumber) {
      obj["serialNumber"] = this.state.serialNumber;
    }

    if (this.state.isFTS) {
      obj["prefix"] = this.state.ftsText;
    } else {
      if (!this.state.itemId) {
        cogoToast.error("Please choose an item.");
        return;
      }
      obj["itemId"] = this.state.itemId;
    }
    try {
      cogoToast.loading("Searching...");
      this.setState({ isSearching: true });
      let res = await apiCallPost(
        `/ims2/${this.props.authStore.prefix}/ledger/search`,
        obj
      );
      this.props.onDataLoad(res);
      this.setState({ isSearching: false });
      cogoToast.success("Search completed.");
    } catch (err) {
      this.setState({ isSearching: false });
      cogoToast.error("We ran into an error while searching.");
    }
  };
  getDataShipment = async () => {
    let obj = { isReceived: this.state.isReceived };

    if (this.state.fromReceivingLocationBranch) {
      obj["fromReceivingLocationBranch"] =
        this.state.fromReceivingLocationBranch;
    }
    if (this.state.toReceivingLocationBranch) {
      obj["toReceivingLocationBranch"] = this.state.toReceivingLocationBranch;
    }
    if (this.state.trackingDetails) {
      obj["trackingDetails"] = this.state.trackingDetails;
    }

    try {
      cogoToast.loading("Searching...");
      this.setState({ isSearching: true });
      let res = await apiCallPost(
        `/ims2/${this.props.authStore.prefix}/ledger/shipmentSearch`,
        obj
      );
      this.props.onDataLoad(res);
      this.setState({ isSearching: false });
      cogoToast.success("Search completed.");
    } catch (err) {
      this.setState({ isSearching: false });
      cogoToast.error("We ran into an error while searching.");
    }
  };
  search = async (
    string,
    searchResArray,
    isSearchingShowSpinner,
    selectedItem,
    apiUrl
  ) => {
    if (!string) {
      this.setState({
        [searchResArray]: [],
        [selectedItem]: null,
      });
      return;
    }
    try {
      this.setState({ [isSearchingShowSpinner]: true });
      let payload = { prefix: string || "" };
      if (apiUrl === "item") {
        payload["showWhich"] = "CURRENT";
      }
      let res = await apiCallPost(
        `/ims2/${this.props.authStore.prefix}/${apiUrl}/search`,
        payload
      );
      let results = res;
      results = _.filter(results, (x) => !x.isShell);
      results = _.filter(results, (x) => !x.isItemGeneratorMother);
      this.setState({
        [searchResArray]: results,
        [isSearchingShowSpinner]: false,
      });
    } catch (err) {
      cogoToast.error(
        "There was an error in searching. Please check the console for more details.",
        { position: "bottom-left" }
      );
      console.log(err);
    }
  };
  renderItemSearch = () => {
    if (this.state.isFTS) {
      return (
        <ControlGroup>
          <Tag
            large
            minimal
            interactive
            onClick={() => this.setState({ isFTS: false })}
          >
            General Search
          </Tag>
          <InputGroup
            style={{ width: "6em" }}
            value={this.state.ftsText}
            onChange={(event) => this.setState({ ftsText: event.target.value })}
          />
        </ControlGroup>
      );
    }
    return (
      <ControlGroup>
        <Tag
          minimal
          large
          interactive
          onClick={() => this.setState({ isFTS: true })}
        >
          Item Search
        </Tag>
        <AsyncSelWrap
          showSelectProp={true}
          placeholder="Items..."
          searching={this.state.searchingItems}
          items={this.state.itemSearchResults.map((each) => {
            return {
              ...each,
              item: each.entityName,
              helper: each.itemNameSuffix,
              entityTypeString: each.isItemService ? "Service" : "Product",
            };
          })}
          selectedItem={
            this.state.searchItem
              ? {
                  ...this.state.searchItem,
                  item: this.state.searchItem.itemNameSuffix
                    ? `${this.state.searchItem.entityName} - ${this.state.searchItem.itemNameSuffix}`
                    : this.state.searchItem.entityName,
                }
              : null
          }
          update={(item) =>
            this.search(
              item,
              "itemSearchResults",
              "searchingItems",
              "searchItem",
              "item"
            )
          }
          onChange={(item) => {
            this.setState({
              searchItem: item,
              itemName: item.itemNameSuffix
                ? `${item.entityName} - ${item.itemNameSuffix}`
                : item.entityName,
              itemId: item._id,
            });
          }}
        />
      </ControlGroup>
    );
  };
  renderItemControlsGeneral = () => {
    return (
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        <ControlGroup>
          <Tag large minimal onRemove={() => this.setState({ location: null })}>
            Branch
          </Tag>
          <SingleSelectWrapper
            items={this.props.sites}
            showSelectProp={true}
            selectedItem={this.state.location}
            onChange={(site) => this.setState({ location: site })}
          />
        </ControlGroup>
        <ControlGroup>
          <Tag large minimal onRemove={() => this.setState({ action: null })}>
            Action
          </Tag>
          <SingleSelectWrapper
            items={["ADD", "REMOVE", "USE", "SHIPMENT", "RETURN"]}
            showSelectProp={true}
            selectedItem={this.state.action}
            onChange={(item) => this.setState({ action: item })}
          />
        </ControlGroup>
        <ControlGroup>
          <Tag large minimal>
            Serial/Batch Number
          </Tag>
          <InputGroup
            value={this.state.enteredSerial}
            onChange={(event) => {
              this.setState({ enteredSerial: event.target.value });
            }}
          />
        </ControlGroup>
        <ControlGroup>
          <Tag
            minimal
            interactive
            onRemove={() =>
              this.setState({ createdInEnd: null, createdInStart: null })
            }
          >
            Created
          </Tag>
          <DateInput
            inputProps={{ style: { width: "8em" } }}
            value={
              this.state.createdInStart
                ? new Date(this.state.createdInStart)
                : null
            }
            formatDate={(date) => niceDate(new Date(date))}
            parseDate={(str) => new Date(str)}
            onChange={(value) => {
              this.setState({ createdInStart: new Date(value) });
            }}
            placeholder="From"
          />
          <Tag minimal icon="arrow-right"></Tag>{" "}
          <DateInput
            inputProps={{ style: { width: "8em" } }}
            value={
              this.state.createdInEnd ? new Date(this.state.createdInEnd) : null
            }
            formatDate={(date) => niceDate(new Date(date))}
            parseDate={(str) => new Date(str)}
            onChange={(value) => {
              this.setState({ createdInEnd: new Date(value) });
            }}
            placeholder="To"
          />
        </ControlGroup>
        <Button
          icon="search"
          intent="success"
          loading={this.state.isSearching}
          onClick={() => this.getDataGeneral()}
        />
      </div>
    );
  };
  renderItemControlsShipment = () => {
    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "flex-start",
          alignItems: "flex-start",
        }}
      >
        <ControlGroup>
          <Tag
            large
            minimal
            onRemove={() =>
              this.setState({ fromReceivingLocationBranch: null })
            }
          >
            Source Branch
          </Tag>
          <SingleSelectWrapper
            items={this.props.sites}
            showSelectProp={true}
            selectedItem={this.state.fromReceivingLocationBranch}
            onChange={(site) =>
              this.setState({ fromReceivingLocationBranch: site })
            }
          />
        </ControlGroup>
        <ControlGroup>
          <Tag
            large
            minimal
            onRemove={() => this.setState({ toReceivingLocationBranch: null })}
          >
            Destination Branch
          </Tag>
          <SingleSelectWrapper
            items={this.props.sites}
            showSelectProp={true}
            selectedItem={this.state.toReceivingLocationBranch}
            onChange={(site) =>
              this.setState({ toReceivingLocationBranch: site })
            }
          />
        </ControlGroup>

        <ControlGroup>
          <Tag large minimal>
            Received?
          </Tag>
          <Tag
            large
            interactive
            icon={this.state.isReceived ? "endorsed" : "cargo-ship"}
            intent={this.state.isReceived ? "success" : "warning"}
            onClick={() => {
              this.setState({ isReceived: !this.state.isReceived });
            }}
          >
            {this.state.isReceived ? "Received" : "In Transit"}
          </Tag>
        </ControlGroup>
        <ControlGroup>
          <Tag large minimal>
            Tracking Details
          </Tag>
          <InputGroup
            value={this.state.trackingDetails}
            onChange={(event) => {
              this.setState({ trackingDetails: event.target.value });
            }}
          />
        </ControlGroup>

        <Button
          icon="search"
          intent="success"
          loading={this.state.isSearching}
          onClick={() => this.getDataShipment()}
        />
      </div>
    );
  };
  renderSearchByMode = () => {
    if (this.state.searchModeGeneral) {
      return (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "flex-start",
          }}
        >
          {this.renderItemSearch()}
          {this.renderItemControlsGeneral()}
        </div>
      );
    } else {
      return (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "flex-start",
            justifyContent: "flex-start",
          }}
        >
          {this.renderItemControlsShipment()}
        </div>
      );
    }
  };
  render() {
    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "flex-start",
          justifyContent: "flex-start",
        }}
      >
        <ControlGroup>
          <Tag
            large
            interactive
            icon={
              this.state.searchModeGeneral ? "full-stacked-chart" : "cargo-ship"
            }
            intent={this.state.searchModeGeneral ? "primary" : "warning"}
            onClick={() => {
              this.setState({
                searchModeGeneral: !this.state.searchModeGeneral,
              });
            }}
          >
            {this.state.searchModeGeneral
              ? "Search: All Actions"
              : "Search: Shipments"}
          </Tag>
        </ControlGroup>
        {this.renderSearchByMode()}
      </div>
    );
  }
}

export default inject("authStore")(observer(LedgerSearchTopBar));
